import { IAntiforgery } from './IAntiforgery';

let getMeta = function (metaName: string): string | null {
    const metas = document.getElementsByTagName('meta');

    for (let i = 0; i < metas.length; i++) {
        if (metas[i].getAttribute('name') === metaName) {
            return metas[i].getAttribute('content') ?? null;
        }
    }
    return null;
}

let data = getMeta('antiforgery');
let tokenData = {} as any;
if (data && data !== null) {
    let json = atob(data);
    tokenData = JSON.parse(json);
}

export default {
    formFieldName: tokenData.field,
    headerName: tokenData.header,
    token: tokenData.token
} as IAntiforgery;
